import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import LeftNav from "../common/leftnav";

const AgentSettings = () => {
  const settings = [
    {
      icon: (
        <img
          src="assets/clipboard-blue.svg"
          alt="Instruction"
          className="nav-icon"
        />
      ),
      title: "Instruction",
      description: "Customize Nouraa to enhance your business call experience.",
      link: "/agent_settings/instructions",
    },
    {
      icon: (
        <img
          src="assets/globe-blue.svg"
          alt="Business Info"
          className="nav-icon"
        />
      ),
      title: "Business Info",
      description:
        "This business information gives Nouraa the context to handle your calls.",
      link: "/agent_settings/business-info",
    },
    {
      icon: <img src="assets/faq.svg" alt="FAQs" className="nav-icon" />,
      title: "FAQs",
      description: "Provide instant answers to common questions.",
      link: "/agent_settings/faqs",
    },
    {
      icon: (
        <img
          src="assets/fluent_book-default-28-regular.svg"
          alt="Knowledge Base"
          className="nav-icon"
        />
      ),
      title: "Knowledge Base",
      description:
        "Information that Nouraa can access to retrieve relevant information during the call.",
      link: "/agent_settings/knowledge_base",
    },
    {
      icon: (
        <img
          src="assets/oui_app-advanced-settings.svg"
          alt="Model Configuration"
          className="nav-icon"
        />
      ),
      title: "Model Configuration",
      description: "Fine-tune Nouraa’s performance using advanced options",
      link: "/agent_settings/model_configuration",
    },
  ];

  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        <h2 className="fw-bold fs-five-title">Agent Settings</h2>
        <p className="gray-color mb-5">
          Customize Nouraa to enhance your business call experience.
        </p>

        {settings.map((item, index) => (
          <>
            {item.title === "Model Configuration" && <hr />}
            <Card key={index} className="mb-3 border-0">
              <Link to={item.link} className="text-decoration-none text-dark">
                <Card.Body className="p-4 d-flex align-items-center justify-content-between">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center">
                      <span>{item.icon}</span>
                      <h6 className="fw-bold mb-0 fs-two">{item.title}</h6>
                    </div>

                    <p className="gray-color mb-0 my-3">{item.description}</p>
                  </div>
                  <span className="fs-5 text-secondary">
                    <img
                      src="assets/arrow-right-sm.svg"
                      alt="Arrow Right"
                      className="nav-icon"
                    />
                  </span>
                </Card.Body>
              </Link>
            </Card>
          </>
        ))}
      </div>
    </div>
  );
};

export default AgentSettings;
